export class IdentifiantExterne {
    public constructor(public idIdentifiantExterne: number,
                       public idUlysse: number,
                       public idAppros: string,
                       public idIntranet: number,
                       public idAssurance: number,
                       public idParCoeur: number,
                       public idAAIDA: string
    ) { }
}
